import { Component, OnInit } from '@angular/core';
//import { ReportsService } from '../../../service/lazarus/reports.service'
import { ReportSponsor } from '../../../model/reportsponsor'
import { StorageService } from '../../../service/managers/storage.service';
import * as moment from 'moment';
import { ReportsService } from '../../../api/reports.service'
//import { Drop } from '../../../api/reports'
import { ReportClass } from '../../../class/reportclass'
import { HelperService,ErrorClass } from '../../../api/helper.service'

import * as FileSaver from 'file-saver';
import { DropDownClass } from '../../../class/dropdownclass';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  sponList:ReportSponsor[] = []

  protected maxItemsPerPage: number;
  protected page: number;
  protected total: number;
  protected keyword: string;

  protected loading: boolean = false;

  dtpFrom: string = '';
  dtpTo:string = '';

  payment_status:DropDownClass[] =[]
  fundraisers:DropDownClass[] =[]
  item:DropDownClass[] =[]
  utm_campaign:DropDownClass[] =[]
  utm_medium:DropDownClass[] =[]
  utm_source:DropDownClass[] =[]
  condition_list:DropDownClass[] =[]
  teams:DropDownClass[] =[]

  reportList:ReportClass[] = []

  constructor(
    private rptAPI: ReportsService,
    private storage: StorageService,
    private help:HelperService,
    //private fileSave:FileSaverService,
  ) { }

  ngOnInit() {
      this.initializeComponents()
  }

  
  payment_staus_id:any = 0
  fundraiser_id:any = 0
  item_id:any = 0
  utm_campaign_name:any = 0
  utm_medium_name:any =0
  utm_source_name:any =0
  condition:any ='and'
  team_name:any = 0

  private getDropdownFilter(){
     this.rptAPI.getDropdownFilter().subscribe(
       (data:any) => {
        this.payment_status = data['payment_status']
        this.fundraisers = data['fundraisers']
        this.item = data['item']
        this.utm_campaign = data['utm_campaign']
        this.utm_medium = data['utm_medium']
        this.utm_source = data['utm_source']
        this.condition_list = data['condition'];
        this.teams = data['teams'];
       },
       (err:ErrorClass) => {
         this.help.msgboxError("Error", err.error_message)
       }
     )
  }

  private initializeComponents() {
      this.rptAPI.getReportList().subscribe(
        (data:ReportClass[]) => {
           this.reportList = data
           this.getDropdownFilter()
           this.reportList = this.reportList.map(
             (val) => {
               val.show_filter=false;
               val.dtp_from = ''
               val.dtp_to
               return val
             }
           )
        },
        (err:ErrorClass) => {
           this.help.msgboxError("Report Error",err.error_message)
        }
      )
  }


  downLoadFile(data: any, type: string,file_name) {
    let blob = new Blob([data], { type: type});
    FileSaver.saveAs(blob, file_name + ".xlsx");  
    this.loading = false
  }
  //************************* EXPORT Functions */


  exportReport(permission_name,dtp_from='',dtp_to=''){
    if(dtp_from!='' && dtp_to!=''){
      dtp_from = this.help.formatDateNew(dtp_from)
      dtp_to = this.help.formatDateNew(dtp_to)
    }
    const body = {
      'permission' : permission_name,
      'payment_status_id' : this.payment_staus_id,
      'date_from' : dtp_from,
      'date_to' : dtp_to,
      'item_id' : this.item_id,
      'fundraiser_id': this.fundraiser_id,
      'utm_campaign' : this.utm_campaign_name,
      'utm_medium' : this.utm_medium_name,
      'utm_source' : this.utm_source_name,
      'condition' : this.condition,
      'team_id' : this.team_name,
    }

    this.loading = true

    this.rptAPI.exportReports(body).subscribe(
      (data) => {
         this.downLoadFile(data,"application/ms-excel",permission_name)
      },
      (err:ErrorClass) => {
        this.help.msgboxError("Error", err.error_message)
        this.loading = false
      }
    )
    // //Get Token
    // const token =this.storage.getAccessToken()
    // let dtpFrom = ''
    // let dtpTo = ''
    // if(this.dtpFrom != '' && this.dtpTo != ''){
    //   dtpFrom = moment(this.dtpFrom).format("YYYY-MM-DD")
    //   dtpTo = moment(this.dtpTo).format("YYYY-MM-DD")
    // }
    // const url = 'https://chosen.worldvision.org.ph/api/sponsor_export?date_from='+dtpFrom+'&date_to='+dtpTo+'&token=' + token;
    // console.log(url)
    // //const url = '/dashboard/sponsor_export?token=' + token;
    // window.open(url, '_blank');
  }

  exportPhotos(){
    // const token =this.storage.getAccessToken()
    // let dtpFrom = ''
    // let dtpTo = ''
    // if(this.dtpFrom != '' && this.dtpTo != ''){
    //   dtpFrom = moment(this.dtpFrom).format("YYYY-MM-DD")
    //   dtpTo = moment(this.dtpTo).format("YYYY-MM-DD")
    // }
    // const url = 'https://chosen.worldvision.org.ph/api/export_photos?date_from='+dtpFrom+'&date_to='+dtpTo+'&token=' + token;
    // //const url = '/dashboard/sponsor_export?token=' + token;
    // window.open(url, '_blank');
  }


  // @HostListener('window:scroll', ['$event'])
  // checkScroll() {

  //   var footerHeight = document.getElementById("footerSection").offsetHeight
  //   const windowScrollTop = $(window).scrollTop()
  //   const windowHeight = (window.innerHeight + footerHeight) - 100;
  //   const documentHeight = document.documentElement.scrollHeight;
  //   console.log('Check Scroll triggered: ' + this.isLoading + '=' + this.isDataAvailable)
  //   if ((windowScrollTop > documentHeight - windowHeight) && this.isLoading === false && this.isDataAvailable === true) {
  //     console.log('Check Scroll Go: ' + this.isLoading + '=' + this.isDataAvailable)
  //     $("#dataLoader").show();
  //     this.isLoading = true;
  //     this.PageNo = this.PageNo + 1;
  //     this.loadItems();
  //     //this.GetReloadAPI();
  //   }
  // }


}
